import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Collapse,
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useState, useEffect } from "react";
import { get, post } from "../../../../utils/api";
import SelectField from "../../../../Components/Masters/SelectField";
//   import formatTitleWithOptional from "../../OptionalFeild";
import InputField from "../../../../Components/Masters/InputField";
import AutoComplete from "../../../../Components/Common/AutoComplete";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import { europeanCountries } from "../../../../utils/countriesArray";
import countries from "../../../../Pages/Masters/Roles and Permissions/Country.json";
import { validateNumber, validateNumberInput } from "../../../../utils/validateFields";
import PhoneFieldInput from "../../../../Components/Masters/PhoneFieldInput";

const EmissionBulkAddForm = ({
  matchData,
  onClose,
  onConfirm,
  onAddItem,
  setMatchData,
  index,
  errors,
  setErrors,
  setFormData,
  formData,
  setExpandedRows,
  bulkuploadInputData,
  url,
  submitUrl,
  fuelType,
  equipment,
  inputData,
  value,
  data,
  matched,
  setsnackOpen
}) => {
  const [equipmentDetails, setEquipmentDetails] = useState([]);

  const [regex, setRegex] = useState({});
  

  const requiredLength = () => {
    // Assuming selectedCountry is available and has the regex string
    const regexString = regex?.key1regex || "^[A-Za-z0-9]{15}$"; // fallback to 15-char alphanumeric
    const match = regexString.match(/\{(\d+)\}/);

    if (match) {
      return parseInt(match[1], 10); // e.g., 15
    }
  };

  const validateForm = (index) => {
    const newErrors = {};
    // setVerify({...verify,emailMsg:"",phoneMsg:""})

    inputData?.forEach((input) => {
      const value = formData?.[index]?.[input.fieldName];
      console.log(input.fieldName, value);

      if (input.fieldName === "contactNumber") {
        const mobileNo = formData?.[index]?.contactNumber?.mobileNo;
        if (!mobileNo)
          newErrors[input.fieldName] = `${input.title} is required`;
        else if (!validateNumber(mobileNo) || mobileNo?.length < 7)
          newErrors[input.fieldName] = "Please enter valid Contact Number";
        if (!formData?.[index]?.email)
          newErrors[input.fieldName] = `${input.title} is required`;
        else if (errors.email) return;
      } else if (input.fieldName === "gstNumber") {
        const reg = new RegExp(`^${value}$`, "i"); // 'i' flag makes it case-insensitive
        const gst = data.filter((el) => reg.test(el.gstNumber));
        // Check if the GST Number already exists and the IDs don't match (or if no GST record exists, skip the validation
        if (gst.length > 0) {
          newErrors[input.fieldName] = `${input.title} Already exists.`;
        }
        const regex1 = new RegExp(regex?.key1regex);
        if (value === "")
          newErrors[input.fieldName] = `${
            regex?.key1 || input.title
          } is Required.`;
        else if (value?.length !== requiredLength() || !regex1.test(value))
          newErrors[input.fieldName] = `Invalid Format`;
      } else if (!value || value === "") {
        newErrors[input.fieldName] = `${input.title} is required`;
      }
    });
    setErrors((prevState) => ({
      ...prevState,
      [index]: { ...prevState[index], ...errors, ...newErrors },
    }));
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value, "name, value",formData[index]);
    let length = null;
    if (name === "contactNumber") {
      const mobileNo = formData?.[index]?.contactNumber?.mobileNo;
      if (!validateNumberInput(value) || value?.length >10)
      return;
    else if(formData?.[index]?.contactNumber?.countryCode === "")
    setErrors((prevState) => ({
      ...prevState,
      [index]: { ...prevState[index], contactNumber: "Please Select Country." },
    }));
    }

    // Assuming selectedCountry is available and has the regex string
    if (name === "gstNumber") {
      length = requiredLength();

      if (length && value?.length > length) {
        return; // skip further updates if too long
      }
    }

    setFormData((prevState) => ({
      ...prevState,
      [index]: {
        ...prevState[index],
        [name]:
          name === "contactNumber"
            ? { ...prevState[index]?.contactNumber, mobileNo: value }
            : value,
      },
    }));

    setErrors((prevState) => ({
      ...prevState,
      [index]: { ...prevState[index], [name]: "" },
    }));

    // Vendor legal name duplication check
    if (name === "vendorLegalName") {
      const regex = new RegExp(`^${value}$`, "i");
      const vendor = data.filter((el) => regex.test(el.vendorLegalName));
      if (vendor.length > 0) {
        setErrors((prevState) => ({
          ...prevState,
          [index]: {
            ...prevState[index],
            [name]: "Vendor Legal Name already exists.",
          },
        }));
      }
      return;
    }

    // GST number duplication and format validation
    if (name === "gstNumber") {
      const gst = data.filter((el) =>
        new RegExp(`^${value}$`, "i").test(el.gstNumber)
      );
      if (gst.length > 0) {
        setErrors((prevState) => ({
          ...prevState,
          [index]: { ...prevState[index], [name]: "Already exists." },
        }));
        return;
      }

      // ✅ Validate format using key1regex from selectedCountry
      const regex1 = new RegExp(regex?.key1regex);
      if (value?.length === length && !regex1.test(value)) {
        setErrors((prevState) => ({
          ...prevState,
          [index]: { ...prevState[index], [name]: `Invalid Format` },
        }));
      }
    }
  };

  const handleCountryChange = (event) => {
    const selectedCountryCode = event.target.value;
    console.log(selectedCountryCode, event.target.name);
    setErrors((prevState) => ({
      ...prevState,
      [index]: { ...prevState[index], country: "", gstNumber: "" },
    }));
    // setVerify({ ...verify, phone: false, phoneMsg: "" });
    const selectedCountry = countries.countries.find(
      (country) => country.name === selectedCountryCode
    );

    if (selectedCountry) {
      // setErrors({ ...errors, contactNumber: "" });
      setFormData((prevData) => ({
        ...prevData,
        [index]: {
          ...prevData[index],
          country: selectedCountry.name,
          gstNumber: "",
          contactNumber: {
            ...prevData[index]?.contactNumber,
            countryCode: selectedCountry.dial_code,
            mobileNo: "",
          },
        },
      }));
      console.log(
        europeanCountries?.find((i) => i?.countryName === selectedCountry.name),
        "regex1"
      );
      setRegex({
        ...europeanCountries?.find(
          (i) => i?.countryName === selectedCountry.name
        ),
      });
      if (errors[index]?.contactNumber === "Please Select Country.")
        setErrors((prevState) => ({
          ...prevState,
          [index]: { ...prevState[index], contactNumber: "" },
        }));
    } else {
      console.error("Country not found in data");
    }
  };


  const handleAddItem = async (index) => {
    console.log(formData[index], validateForm(index), "formData[index]");
    if (!validateForm(index)) {
      return;
    }

    const itemData = {
      //   equipment: matchData[index].equipment,
      ...formData[index],
    };

      try {
        // Make API call here
        // Example: const response = await addEquipmentAPI(itemData);
        const response = await post(submitUrl, itemData);
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        // For now, simulate API call success
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Update the status to matched on success
        if (setMatchData) {
          setMatchData((prev) =>
            prev.map((item, i) =>
              i === index ? { ...item, [matched]: true } : item
            )
          );
        }

        // Call the parent handler if provided
        if (onAddItem) {
          onAddItem(itemData, index);
        }

        // Close the expanded row
        setExpandedRows((prev) => ({
          ...prev,
          [index]: false,
        }));

        // Clear form data and errors for this index
        setFormData((prev) => {
          const newData = { ...prev };
          delete newData[index];
          return newData;
        });
        

        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[index];
          return newErrors;
        });
      } catch (error) {
        console.error("Error adding equipment:", error);
        // Handle error - you can show an error message here
      }
  };
  return (
    <Box
      sx={{
        margin: 1,
        // backgroundColor: "#f8f9fa",
      }}
    >
      <Typography variant="h6" gutterBottom component="div">
        Add Vendor:
      </Typography>
      <Grid container spacing={2}>
        {bulkuploadInputData?.map((items, i) => (
          <Grid item xs={12} sm={6} key={i}>
            {items.fieldName === "contactNumber" ? (
              <Box>
                <PhoneFieldInput
                //   name={items.fieldName}
                  value={formData?.[index]?.contactNumber?.mobileNo || ""} // Use optional chaining
                  errors={errors?.[items.fieldName]}
                  handleChange={handleChange}
                  fieldName={items.fieldName}
                  placeholder={items.placeholder}
                  title={items.title}
                  {...{
                    setErrors,
                    setFormData,
                    formData,
                  }}
                  countryCode={
                    formData?.[index]?.contactNumber?.countryCode || ""
                  } // Use optional chaining
                />
              </Box>
            ) : items.type === "text" || items.type === "number" ? (
              <InputField
                title={items.title}
                handleChange={handleChange}
                placeholder={items.placeholder}
                errors={errors?.[items.fieldName]}
                value={
                  items.title === "Equipment Name"
                    ? equipment
                    : items.title === "Fuel Type"
                    ? fuelType
                    : formData[index]?.[items.fieldName] || ""
                }
                fieldName={items.fieldName}
                disabled={items?.fieldName === "vendorLegalName"}
                type={items.type}
              />
            ) : (
              <SelectField
                title={items.title}
                name={items.fieldName}
                value={formData?.[index]?.[items.fieldName]}
                handleChange={handleCountryChange}
                options={countries?.countries}
                errors={errors?.[items.fieldName]}
              />
            )}
          </Grid>
        ))}

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleAddItem(index)}
              sx={{ mt: 1 }}
            >
              Add Vendor
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default EmissionBulkAddForm;
